<script lang="ts">
  import { onDestroy } from 'svelte';

  import type { TeoText } from '@/teoCore/text/TeoText';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  let { text }: { text: TeoText } = $props();
  let headline: string = $state('');
  let textRight: string = $state('');
  let textTitle = useTeoTextUiStateObserver(text.ui, 'title');
  setDate();
  const destoryTextChangedHandler = text.events.addEventListener('textChanged', setDate);
  $effect(() => {
    headline = textTitle.current;
  });
  onDestroy(() => {
    destoryTextChangedHandler();
  });

  function setDate() {
    textRight = new Date(text.lastEdited).toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }); // 11.11.24 13:30
  }
</script>

{#if textRight}
  <h3 class="float-right mb-3 mr-2 text-label-xs text-c-light">{textRight}</h3>
{/if}
<h3 class="mb-3 ml-2 text-label-xs font-bold uppercase">{headline}</h3>
